'use client'

import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconCaretLeft } from '@redteclab/icons'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetBrandsIndexPage } from '../../../../url-handling'

import { StoryblokBrandBreadcrumbs } from './StoryblokBrandBreadcrumbs'

export const StoryblokBrandHeader: FC<{ title: string | undefined }> = ({
  title,
}) => {
  const publicGlobalConfig = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <>
      {title ? <StoryblokBrandBreadcrumbs currentBrand={title} /> : null}
      <section className="container flex items-center">
        <a
          aria-label={intl.formatMessage({
            id: 'general.link.label.backToBrandIndex',
          })}
          href={urlResolverGetBrandsIndexPage(publicGlobalConfig)}
        >
          <IconCaretLeft className="size-11 shrink-0 text-dark-brand" />
        </a>
        {title ? <h1 className="text-4xl">{title}</h1> : null}
      </section>
    </>
  )
}
